import {createTheme, ThemeOptions} from "@mui/material";
import {DEFAULT_THEME_OPTIONS, nightGray} from "@/shared/colors";
import {CARD_SHADOW, PD_LG, PD_XSM} from "@/shared/dimens";
import {SiteTemplate} from "../../types";
import {HeroSection} from "./HeroSection";
import {AddressSection} from "./AddressSection";
import {ContactSection} from "./ContactSection";
import {FaqSection} from "./FaqSection";
import {FooterSection} from "./FooterSection";
import {GallerySection} from "./GallerySection";
import {HeaderSection} from "./HeaderSection";
import {HighlightSection} from "./HighlightSection";
import {PromoSection} from "./PromoSection";
import {ServicesSection} from "./ServicesSection";
import {StatsSection} from "./StatsSection";
import {TeamSection} from "./TeamSection";
import {TestimonialsSection} from "./TestimonialsSection";
import {FontManager} from "@/shared/fonts";

const fontManager = FontManager.getInstance();
export const HeadingFont = fontManager.getFont("DM_Serif_Display");
export const BodyFont = fontManager.getFont("DM_Sans");

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiPaper: {
      styleOverrides: {
        elevation: {
          boxShadow: CARD_SHADOW,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: "600",
          borderRadius: 0,
          minHeight: 48,
          paddingTop: PD_XSM,
          paddingBottom: PD_XSM,
          paddingLeft: PD_LG,
          paddingRight: PD_LG,
          textTransform: "none",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          backgroundColor: nightGray,
        },
        tooltip: {
          backgroundColor: nightGray,
          fontSize: "90%",
        },
      },
    },
  },
  typography: {
    h1: {
      fontWeight: "400",
      fontSize: "4rem",
      letterSpacing: -1.0,
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.05,
    },
    h2: {
      fontWeight: "400",
      fontSize: "3rem",
      letterSpacing: -0.8,
      fontFamily: HeadingFont.style.fontFamily,
      lineHeight: 1.1,
    },
    h3: {
      fontWeight: "400",
      fontSize: "2rem",
      letterSpacing: -0.6,
      fontFamily: HeadingFont.style.fontFamily,
    },
    h4: {
      fontWeight: "500",
      fontSize: "1.5rem",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h5: {
      fontWeight: "500",
      fontSize: "1.2rem",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h6: {
      fontWeight: "600",
      fontFamily: BodyFont.style.fontFamily,
    },
    fontSize: 17,
    fontFamily: BodyFont.style.fontFamily,
  },
  palette: {
    primary: {
      main: "#C4614A",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FBF5EE",
      contrastText: "#C4614A",
    },
  },
};

export const CALIFORNIA_TEMPLATE: SiteTemplate = {
  name: "california",
  text: "California",
  theme: createTheme(THEME_OPTIONS),
  themeExtras: {
    highlightColor: "#FBF5EE",
  },
  PageSections: {
    AddressSection: AddressSection,
    ContactSection: ContactSection,
    FaqSection: FaqSection,
    FooterSection: FooterSection,
    GallerySection: GallerySection,
    HeaderSection: HeaderSection,
    HeroSection: HeroSection,
    HighlightSection: HighlightSection,
    PromoSection: PromoSection,
    ServicesSection: ServicesSection,
    StatsSection: StatsSection,
    TeamSection: TeamSection,
    TestimonialsSection: TestimonialsSection,
  },
};
